import { defineField, defineType } from "sanity";

export const captionType = defineType({
  type: "object",
  name: "captionType",
  title: "Caption",
  fields: [
    defineField({
      name: "language",
      type: "string",
      title: "Language"
    }),
    defineField({
      name: "srt",
      type: "object",
      title: "SRT",
      fields: [
        defineField({
          name: "path",
          type: "string",
          title: "Path"
        }),
        defineField({
          name: "mimetype",
          type: "string",
          title: "Mimetype"
        }),
        defineField({
          name: "url",
          type: "string",
          title: "URL"
        })
      ]
    })
  ],
  preview: {
    select: {
      title: "language",
      subtitle: "srt.path"
    }
  }
});
